<template>
  <span class="upper-cent-price">
    <span class="upper-cent-price__body">
      <span
        v-if="isCurrencyBefore"
        class="upper-cent-price__currency-symbol">
        {{ activeRegion.currency.symbol }}
      </span>
      <span class="upper-cent-price__int">
        {{ price.int }}
      </span>
      <span
        v-if="price.decimalInt"
        class="upper-cent-price__cent">
        {{ String(price.decimalInt).padStart(2, '0') }}
      </span>
      <span
        v-if="!isCurrencyBefore"
        class="upper-cent-price__currency-symbol">
        {{ activeRegion.currency.symbol }}
      </span>
    </span>
  </span>
</template>

<script>
import { mapState } from 'vuex';
import { splitFloat } from 'Root/helpers/tools';
import CurrencyModel from 'Models/CurrencyModel';

export default {
  name: 'UpperCentsPrice',

  props: {
    sum: {
      type: [Number, String],
      required: true,
    },
  },

  computed: {
    ...mapState(['activeRegion']),

    price() {
      return splitFloat(this.sum, 2);
    },

    isCurrencyBefore() {
      return this.activeRegion.currency.position === CurrencyModel.position.before;
    },
  },
};
</script>

<style lang="scss" scoped>
  .upper-cent-price {
    //--font-size: 1em;
    //--font-size--cent: 0.4em;
    --cent-margin: 0 0 0 2px;
    --color: #{$color--basic-white};
    --text-decoration: none;
  }

  .upper-cent-price__body {
    color: var(--color);
    font-weight: 500;
    display: inline-flex;
    align-items: flex-start;
    text-decoration: var(--text-decoration);
  }

  .upper-cent-price__currency-symbol,
  .upper-cent-price__int {
    font-size: var(--font-size, 1em);
    line-height: 1.15;
  }

  .upper-cent-price__cent {
    font-size: var(--font-size--cent, 0.4em);
    margin: var(--cent-margin);
  }
</style>
